import { useTranslation } from 'react-i18next';
import { cn } from '../../common/functions/cn';
import { buttonV2Variants } from '../button-v2/button-v2';
import InnerHTMLDiv from '../common/inner-html-div.component';
import { Popover, type PopoverAlign, PopoverContent, type PopoverSide, PopoverTrigger } from '../popover/popover';

export interface HelpComponentProps {
  description: string;
  align?: PopoverAlign;
  side?: PopoverSide;
  className?: string;
}

export default function HelpComponent({ description, align = 'end', side, className }: HelpComponentProps) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger
        openOnHover
        aria-label={t('help')}
        className={cn(
          buttonV2Variants({ variant: 'default', size: 'icon' }),
          'size-4.5 cursor-default rounded-full bg-info font-medium text-xs hover:bg-info/90 aria-expanded:bg-info/90',
          className
        )}
      >
        <span>?</span>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        side={side}
        className="max-h-[calc(100dvh-2rem)] w-auto max-w-[calc(100vw-2rem)] sm:max-w-prose"
      >
        <InnerHTMLDiv className="overflow-y-auto" html={description} />
      </PopoverContent>
    </Popover>
  );
}
